import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./FloatingActions.css";

export default function FloatingActions() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 120);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`float-actions ${show ? "is-show" : ""}`}>
      {/* Haqqımızda */}
      <Link className="fab fab-about" to="/haqqimizda" aria-label={t("about")}>
        <span className="fab-ic" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="36" height="36">
            <path
              d="M4 6h16M4 12h16M4 18h10"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
            />
          </svg>
        </span>
        <span className="fab-label">{t("about")}</span>
      </Link>

      {/* İletişim */}
      <Link className="fab fab-contact" to="/elaqe" aria-label={t("contact")}>
        <span className="fab-ic" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="36" height="36">
            <path
              d="M12 22s7-4.5 7-12a7 7 0 10-14 0c0 7.5 7 12 7 12z"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
            <circle cx="12" cy="10" r="2.5" fill="currentColor" />
          </svg>
        </span>
        <span className="fab-label">{t("contact")}</span>
      </Link>

      {/* ✅ Telefon (tel: açır => brauzer "Pick an application" pəncərəsini göstərə bilər) */}
      <a
        className="fab fab-phone"
        href="tel:+994602113435" // öz nömrəni yaz
        aria-label={t("float.phone")}
        title={t("float.phone")}
      >
        <span className="fab-ic" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="36" height="36">
            <path
              d="M6.62 10.79a15.1 15.1 0 0 0 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.07 21 3 13.93 3 5c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.24.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span className="fab-label">{t("float.phone")}</span>
      </a>
    </div>
  );
}
